module.exports = __webpack_public_path__ + "b31cdeee05cb0bd2b11fbf091af0de67.svg";